import { BaseService } from './base.service'

export class EmployeePaidLeaveService extends BaseService {
  static get entity () {
    return '/employee/paid-leave'
  }
}

export class GetContractEmployeeServices extends BaseService {
  static get entity () {
    return '/employee/contract/all'
  }
}
